import Select from 'react-select';

type OptionType = {
	value: string,
	label: string
}

export type SelectedOptionType = OptionType | null;

interface DropdownProps {
	id: string,
	options: OptionType[],
	searchable?: boolean,
	onChange: (value: string) => void
};

const ReactSelectCustomStyles = {
	container: () => ({
		width: 'auto',
		fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"
	}),
	control: () => ({
		display: 'flex',
		alignItems: 'center',
		border: 0,
		borderBottom: '2px solid #1d1d1d'
	}),
	valueContainer: () => ({
		width: 150,
		fontSize: 14,
		cursor: 'pointer'
	}),
	indicatorsContainer: () => ({
		width: 20,
		marginTop: 5,
	}),
	indicatorSeparator: () => ({
		border: 0
	}),
	dropdownIndicator: () => ({
		border: 0
	}),
	input: () => ({
		width: '100%'
	}),
	menu: (provided: any, state: any) => ({
		...provided,
		width: 170,
		border: 0,
		boxShadow: 0,
		marginTop: '-10px'
	}),
	menuList: (provided: any, state: any) => ({
		...provided,
		width: 170,
		border: 0,
		color: '#fff',
		backgroundColor: '#333'
	}),
	singleValue: (provided: any, state: any) => ({
		...provided,
		fontWeight: 500
	}),
	option: (provided: any, state: any) => ({
		...provided,
		cursor: 'pointer',
		padding: '10px 15px',
		fontWeight: state.isSelected ? 500 : 400,
		color: state.isFocused || state.isSelected ? '#fff' : '#ccc',
		textShadow: 0,
		backgroundColor: 'transparent !important'
	})
};

const Dropdown = ( {
	id,
	options,
	searchable,
	onChange
}: DropdownProps ) => {
	function handleChange(selectedOption: SelectedOptionType) {
		selectedOption && onChange(selectedOption.value);
	}

	return (
		<Select
			id={id}
			className="rg-dropdown"
			classNamePrefix="rg-dropdown"
			options={options}
			defaultValue={options[0]}
			isSearchable={searchable || false}
			onChange={handleChange}
			styles={ReactSelectCustomStyles}
		/>
	)
}

export default Dropdown;
